import FingoMuiMobileStepper from '../../fingo/components/MuiMobileStepper';
import DEFAULT_MOBILE_STEPPER_CLASS_NAME from '../../constants/mobile-stepper';

export const defaultMobileStepperStyles = ({ theme }) => ({
  '& .MuiMobileStepper-dotActive': {
    backgroundColor: theme.palette.secondary.A400,
  },
});

const MuiMobileStepper = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiMobileStepper.styleOverrides.root({ theme }),
      [`&.${DEFAULT_MOBILE_STEPPER_CLASS_NAME}`]: defaultMobileStepperStyles({ theme }),
    }),
  },
};

export default MuiMobileStepper;
